import { useMemo } from "react";
import { useWindowSize } from "react-use";

import arrowRightIcon from "constants/modelCompareData/assets/arrow-right.svg";
import { useModelCompareTranslation } from "constants/modelCompareData/translations/useModelCompareTranslation";
import { StyleableSvgImage } from "@ubnt/store.core/lib/components/StyleableSvgImage";
import { MOBILE_BREAKPOINT } from "../../../CompareTable/CompareTable.styles";
import * as S from "./ScrollButton.styles";

const icon = arrowRightIcon;

export const ScrollButton = ({
  color,
  rotationDegrees,
  isVisible,
  isRightButton,
  onClick,
}: {
  color: string;
  rotationDegrees: number;
  isVisible: boolean;
  isRightButton?: boolean;
  onClick: () => void;
}) => {
  const { width: screenWidth } = useWindowSize();
  const isSmallScreen = screenWidth < MOBILE_BREAKPOINT;
  const placeButtonsOverCards = screenWidth < 1450;

  const { formatMessage } = useModelCompareTranslation();

  const arrowOffset = useMemo(() => {
    if (isSmallScreen) {
      return rotationDegrees < 180 ? -5 : 0;
    }

    return -15;
  }, [isSmallScreen, rotationDegrees]);

  return (
    <S.Button
      aria-label={
        isRightButton
          ? formatMessage("commons.scrollButton.right")
          : formatMessage("commons.scrollButton.left")
      }
      $color={color}
      $rotation={rotationDegrees}
      $isVisible={isVisible}
      $isRightButton={Boolean(isRightButton)}
      $placeButtonsOverCards={placeButtonsOverCards}
      type="button"
      onClick={onClick}
    >
      <S.Icon $rotation={rotationDegrees} $arrowOffset={arrowOffset}>
        <StyleableSvgImage width={10} height={16} src={icon} />
      </S.Icon>
    </S.Button>
  );
};
